// valida se telefone tem entre 10 e 11 digítos
export default function validaTel(val) {
  let r = val.match(/\d/g)
  if (!r) return null
  let len = r.join("").length
  if (len < 10) return "Faltam caracteres"
  if (len > 11) return "Contém mais caracteres"
  return null
}
